var $ = require('jquery');
var accordionTitle = $('.accordion__title');
accordionTitle.each(function() {
    $(this).on('click', function() {
        $(this).parent().toggleClass('active');
        toggle($(this));
    })
})

$(window).on('resize', function() {
    accordionTitle.each(function() {
        toggle($(this));
    })
})

function toggle(el) {
    
    let height = calcHeight(el);
    if ( el.parent().hasClass('active') ) {
        el.parent().find('.accordion__content').css("maxHeight", height);
    } else {
        el.parent().find('.accordion__content').css("maxHeight", 0);
    }
}

function calcHeight(el) {
    return el.parent().find('.accordion__content')[0].scrollHeight;
}